import fileField from './fileField';

export default () => {
  fileField();
};
